import type { InspectionCompany } from 'api';
import type { SelectOption } from 'form';

import { sortByName } from '../sortByName/sortByName';
export const getCompanyOptions = (companies: InspectionCompany[]): SelectOption[] => {
  return companies
    .sort((companyA, companyB) => sortByName(companyA.name, companyB.name))
    .map((company) => ({
      label: company.name,
      value: company.id,
    }));
};
